export const AccessPointConfig = {
  euloginUrl: window.env.EULOGIN_URL
};
